import { useQuery } from '@tanstack/react-query'
import { scheduleApi } from '../api/schedule'
import { useSpoke } from './useSpoke'

// "Will it run the scans itself?" — one hook for the answer. It refetches on a slow beat because a
// chain moves at the pace of the jobs it starts, and each of those has its own live console.
export function useSchedule() {
  const spoke = useSpoke()
  return useQuery({
    queryKey: ['schedule', spoke],
    queryFn: () => scheduleApi.get(spoke),
    staleTime: 15_000,
    refetchInterval: (query) => (query.state.data?.lastRun?.open ? 10_000 : 60_000),
  })
}
